import React, { useState } from 'react';
import styles from './deleteModal.module.css';

const DeleteModal = ({ isOpen, onClose, onDelete, heading, title, description, loading, requirePassword = true }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    if (!isOpen) return null;

    const handleClose = () => {
        setPassword('');
        setError('');
        setShowPassword(false);
        onClose();
    };

    const handleDelete = () => {
        if (requirePassword && !password.trim()) {
            setError('Please enter Super Admin password to confirm');
            return;
        }
        setError('');
        onDelete(password);
    };

    const formatHeading = (str) => {
        if (!str) return 'Item';
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const modalTitle = title || (
        heading === 'all product' || heading === 'all products'
            ? 'Delete All Products'
            : heading === 'selected products'
            ? 'Delete Selected Products'
            : `Delete ${formatHeading(heading)}`
    );

    const modalDescription = description || (
        heading === 'all product' || heading === 'all products'
            ? 'Are you sure you want to delete all products?'
            : heading === 'selected products'
            ? 'Are you sure you want to delete the selected products?'
            : `Are you sure you want to delete this ${heading || 'item'}?`
    );

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <div className={styles.modalBody}>
                    <div className={styles.iconContainer}>
                        <svg className={styles.warningIcon} fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                        </svg>
                    </div>
                    <div className={styles.textContainer} style={{ width: '100%' }}>
                        <h3 className={styles.modalTitle}>{modalTitle}</h3>
                        <p className={styles.modalDescription}>
                            {modalDescription}
                        </p>

                        {requirePassword && (
                            <div className={styles.passwordContainer}>
                                <label className={styles.passwordLabel}>Confirm Super Admin Password</label>
                                {/* Deliberately NOT type="password": Chrome's password manager treats any
                                    password field as a login form and autofills the saved email into the
                                    nearest text box on the page (the search bar). A text input masked with
                                    CSS looks the same but is ignored by the password manager. */}
                                <div style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    name="confirm_code"
                                    id="confirm_code"
                                    autoComplete="off"
                                    autoCorrect="off"
                                    autoCapitalize="off"
                                    spellCheck={false}
                                    data-lpignore="true"
                                    data-form-type="other"
                                    className={styles.passwordInput}
                                    style={{ WebkitTextSecurity: showPassword ? 'none' : 'disc', paddingRight: '44px' }}
                                    placeholder="Enter Super Admin password"
                                    value={password}
                                    onChange={(e) => {
                                        setPassword(e.target.value);
                                        if (error) setError('');
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleDelete();
                                        }
                                    }}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword((v) => !v)}
                                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                                    style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', border: 'none', background: 'transparent', cursor: 'pointer', color: '#667085', fontSize: 12, fontWeight: 600, padding: '4px 6px' }}
                                >
                                    {showPassword ? 'Hide' : 'Show'}
                                </button>
                                </div>
                                {error && <div className={styles.errorText}>{error}</div>}
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.modalFooter}>
                    <button onClick={handleClose} className={styles.cancelButton} disabled={loading}>
                        Cancel
                    </button>
                    <button onClick={handleDelete} className={styles.deleteButton} disabled={loading}>
                        {loading ? "Deleting..." : "Delete"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;
